import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Col, DatePicker, Form, Input, message, Row, Select, Checkbox, Space } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Link, useNavigate, useParams } from 'react-router-dom';
import initialTermsCondition from '../../Common/intialTermsCondition';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAlloyDropdown,
  resetAlloyList,
  resetCurrentAlloyListPage,
} from '../../slices/alloy';
import {
  fetchTemperDropdown,
  resetCurrentTemperPage,
  resetTempersList,
} from '../../slices/tempers';
import {
  fetchDieProfileById,
  fetchDieProfileDropdown,
  resetCurrentDieProfilePage,
  resetDieProfileData,
  resetDieProfileList,
} from './../../slices/die-profile';
import { fetchQuotationById, updateQuotation } from '../../slices/quotation';
import {
  fetchCustomerConversionList,
  fetchCustomerDropdown,
  resetCurrentCustomerPage,
  resetCustomerList,
} from '../../slices/customer';

import {
  fetchConversionRateList,
  resetConversionRateList,
} from '../../slices/conversion-rate';
import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import { debounce } from 'lodash';
import { fetchPackingModeList, resetPackingModeData } from '../../slices/packing';
import { fetchjobWorkList, resetJobWorkList } from '../../slices/job-work';
const { Option } = Select;

export default function EditQuotation() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [form] = Form.useForm();
  const { id } = useParams();
  const [editorValue, setEditorValue] = useState(initialTermsCondition);
  const [searchTemper, setSearchTemper] = useState('');
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [btnLoading, setBtnLoading] = useState(false);
  const [searchAlloy, setSearchAlloy] = useState('');

  const [page, setPage] = useState(1);
  const [searchCustomer, setSearchCustomer] = useState('');
  const [pagesize, setPageSize] = useState(10);
  const [selectCustomer, setSelectCustomer] = useState(null);
  const [selectedDieProfile, setSelectedDieProfile] = useState(null); // always start with an array
  const [selectedTemper, setSelectedTemper] = useState(null);
  const [selectedAlloy, setSelectedAlloy] = useState(null);
  const [currentWTKg, setCurrentWTKg] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedSurfaceFinish, setSelectedSurfaceFinish] = useState('');
  const [selectedEngineeringOptions, setSelectedEngineeringOptions] = useState(
    {},
  );
  const [selectedJobWork, setSelectedJobWork] = useState('');
  const { list: customerDropdown } = useSelector(state => state.customer);
  const { data: packingModeList, loading: packingModeLoading } = useSelector(state => state.packingMode);
  const {
    list: dieProfileDropdown,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);
  const {
    list: alloyDropdown,
    loading: alloyLoading,
    currentPage: alloyCurrentPage,
    hasMore: alloyHasMore,
  } = useSelector(state => state.alloy);
  const {
    list: temperDropDown,
    loading: temperLoading,
    hasMore: temperHasMore,
  } = useSelector(state => state.temper);
  const { jobWorkdata, loading: jobWorkLoading } = useSelector(
    state => state.jobWork,
  );
  useEffect(() => {
    fetchAlloyDropdown();
    fetchTemperDropdown();
    fetchDieProfileDropdown();
    fetchConversionRateList();
    fetchCustomerDropdown();
    dispatch(fetchjobWorkList());
    dispatch(fetchPackingModeList({ page: 1, pagesize: 100 }));
    resetAlloyList();
    resetTempersList();
    resetCurrentDieProfilePage();
    resetDieProfileList();
    resetConversionRateList();
    resetCustomerList();
    resetJobWorkList();
    resetPackingModeData();
  }, []);

  useEffect(() => {
    dispatch(resetJobWorkList());
  }, [dispatch, page, pagesize]);

  useEffect(() => {
    const fetchQuotation = async () => {
      try {
        const response = await dispatch(fetchQuotationById(id)).unwrap();
        if (response?.success) {
          const quotationDetails =
            response?.data?.quotation_details?.length > 0
              ? response?.data?.quotation_details.map(detail => ({
                id: detail?.id || null,
                die_profile: detail.die_profile
                  ? {
                    label: detail.die_profile.die_number,
                    value: detail.die_profile.id,
                  }
                  : undefined,
                customer_reference_no: detail.customer_reference_no || '',
                conversion: detail.conversion || '',
                alloy: detail.alloy
                  ? {
                    label: `${detail.alloy.alloy_code}${detail.alloy.standard_name ? ' - ' + detail.alloy.standard_name : ''}`,
                    value: detail.alloy.id,
                  }
                  : null,
                temper: detail.temper ? { label: detail.temper.temper_code_new, value: detail.temper.id } : undefined,
                length: detail.length || null,
                finishing_price: detail.finishing_price || null,
                price_per_kg: detail.price_per_kg || '',
                unit_of_measurement: detail.unit_of_measurement || '',
                description: detail.description || '',
                surface_treatment: detail.surface_treatment || '',
                surface_finish: detail.surface_finish || '',
                net_weight: detail.net_weight || null,
                pieces: detail.pieces || null,
                wt_kg_p_mt: detail.die_profile?.wt_kg_p_mt || null,
                jobworks: detail?.jobworks ? detail?.jobworks : [],
                cutting: detail.cutting || false,
                machining: detail.machining || false,
                deburring: detail.deburring || false,
                cutting_price: detail.cutting_price || undefined,
                machining_price: detail.machining_price || undefined,
                deburring_price: detail.deburring_price || undefined,
                anodising: detail.anodising || false,
                powder_coating: detail.powder_coating || false,
                pvdf: detail.pvdf || false,
                anodising_description:
                  detail.anodising_description || undefined,
                anodising_price: detail.anodising_price || undefined,
                powder_coating_description:
                  detail.powder_coating_description || undefined,
                powder_coating_price:
                  detail.powder_coating_price || undefined,
                pvdf_description: detail.pvdf_description || undefined,
                pvdf_price: detail.pvdf_price || undefined,
                out_source: detail.out_source != null ? detail.out_source : null,
                laser_marking_description: detail.laser_marking_description || undefined,
                laser_marking_price: detail.laser_marking_price || undefined,
              }))
              : [
                {
                  die_profile: undefined,
                  customer_reference_no: '',
                  alloy: null,
                  temper: undefined,
                  length: null,
                  conversion: '',
                  finishing_price: null,
                  price_per_kg: '',
                  unit_of_measurement: '',
                  description: '',
                  surface_treatment: '',
                  surface_finish: '',
                  net_weight: null,
                  pieces: null,
                  jobworks: [],
                  cutting: false,
                  machinings: false,
                  deburring: false,
                  cutting_price: undefined,
                  machining_price: undefined,
                  deburring_price: undefined,
                  anodising: false,
                  powder_coating: false,
                  pvdf: false,
                  anodising_description: undefined,
                  anodising_price: undefined,
                  powder_coating_description: undefined,
                  powder_coating_price: undefined,
                  pvdf_description: undefined,
                  pvdf_price: undefined,
                  laser_marking_description: undefined,
                  laser_marking_price: undefined,
                  out_source: null,
                },
              ];

          form.setFieldsValue({
            customer: response?.data?.customer?.id || null,
            quotation_date: response?.data?.quotation_date ? dayjs(response?.data?.quotation_date) : null,
            project_name: response?.data?.project_name || '',
            remarks: response?.data?.remarks || null,
            packing_mode: response?.data?.packing_mode || [],
            terms_and_condition: response?.data?.terms_and_condition || '',
            quotation_details: quotationDetails,
          });

          setSelectCustomer(response?.customer?.id || null);
          setEditorValue(
            response?.data?.terms_and_condition || '',
          );

          setSelectedDieProfile(
            quotationDetails
              .map(item => item.die_profile?.value)
              .filter(Boolean),
          );
          setSelectedAlloy(
            quotationDetails.map(item => item.alloy?.value).filter(Boolean),
          );
          setSelectedTemper(
            quotationDetails.map(item => item.temper?.value).filter(Boolean),
          );
          setCurrentWTKg(quotationDetails[0]?.wt_kg_p_mt || 0);
        }
      } catch (error) {
        console.error('Error fetching quotation:', error);
      }
    };

    fetchQuotation();
  }, [id, form, dispatch]);


  useEffect(() => {
    if (form.getFieldValue('terms_and_condition')) {
      setEditorValue(form.getFieldValue('terms_and_condition'));
    }
  }, [form.getFieldValue('terms_and_condition')]);

  const handleChange = content => {
    setEditorValue(content);
    form.setFieldsValue({ terms_and_condition: content });
  };



  const handleDieProfileChange = async (value, index) => {
    const updatedQuotationDetails = [
      ...form.getFieldValue('quotation_details'),
    ];
    updatedQuotationDetails[index] = {
      ...updatedQuotationDetails[index],
      die_profile: value?.value,
      conversion: '',
    };
    form.setFieldsValue({ quotation_details: updatedQuotationDetails });
    setSelectedIndex(index);

    try {
      const response = await dispatch(
        fetchDieProfileById(value?.value),
      ).unwrap();
      if (response?.results?.data?.length > 0) {
        const customerRefNo =
          response.results.data[0]?.customer_reference_number || '';
        const currentWTKg = response.results.data[0]?.wt_kg_p_mt || '';
        setCurrentWTKg(currentWTKg);

        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          customer_reference_no: customerRefNo,
          wt_kg_p_mt: currentWTKg,
          conversion: '',
        };

        form.setFieldsValue({
          quotation_details: updatedQuotationDetails,
          customer_reference_no: customerRefNo,
        });

        const customerId = form.getFieldValue('customer');
        if (customerId) {
          await fetchConversionData(customerId, value?.value, index);
        }
      }
    } catch (error) {
      console.error('Error fetching customer reference number:', error);
    }
  };
  const handleFieldChange = (index, changedField) => {
    const workOrderDetails = form.getFieldValue('quotation_details') || [];
    const row = { ...workOrderDetails[index] } || {};
    const currentKg = row?.wt_kg_p_mt || currentWTKg || 0;
    const length = parseFloat(row.length) || 0;
    const pieces = parseFloat(row.pieces) || 0;
    const net_weight = parseFloat(row.net_weight) || 0;

    let calculatedNetWeight = net_weight;
    let calculatedPieces = pieces;
    if (
      changedField === 'net_weight' &&
      net_weight > 0 &&
      length > 0 &&
      currentKg > 0
    ) {
      calculatedPieces = net_weight / (currentKg * (length / 1000));
    } else if (
      (changedField === 'pieces' || changedField === 'length') &&
      pieces > 0 &&
      length > 0 &&
      currentKg > 0
    ) {
      calculatedNetWeight = ((currentKg * length) / 1000) * pieces;
      calculatedNetWeight = Number(calculatedNetWeight).toFixed(3);
    }

    const toleranceValue = form.getFieldValue('tolerance') || '';
    const tolerancePercent = toleranceValue
      ? parseFloat(toleranceValue.replace(/[^\d.]/g, '')) || 0
      : 0;
    const isPositive = toleranceValue.includes('+');
    const isNegative = toleranceValue.includes('-');
    let max_weight = Number(calculatedNetWeight);
    let min_weight = Number(calculatedNetWeight);

    if (tolerancePercent > 0) {
      if (isPositive && isNegative) {
        max_weight = calculatedNetWeight * (1 + tolerancePercent / 100);
        min_weight = calculatedNetWeight * (1 - tolerancePercent / 100);
      } else if (isPositive) {
        max_weight = calculatedNetWeight * (1 + tolerancePercent / 100);
        min_weight = calculatedNetWeight;
      } else if (isNegative) {
        min_weight = calculatedNetWeight * (1 - tolerancePercent / 100);
        max_weight = calculatedNetWeight;
      }
    }

    const updatedWorkOrderDetails = [...workOrderDetails];
    const updatedRow = {
      ...row,
      net_weight: calculatedNetWeight,
      max_weight: Number(max_weight).toFixed(3),
      min_weight: Number(min_weight).toFixed(3),
      wt_kg_p_mt: currentKg,
    };

    if (changedField === 'net_weight' || changedField === 'length') {
      updatedRow.pieces = Math.round(calculatedPieces);
    }

    updatedWorkOrderDetails[index] = updatedRow;
    form.setFieldsValue({
      quotation_details: updatedWorkOrderDetails,
    });
  };

  const handleprofile = selected => {
    form.setFieldsValue({
      quotation_details: form
        .getFieldValue('quotation_details')
        .map((item, index) =>
          index === selected.index ? { ...item, die_profile: selected } : item,
        ),
    });
  };

  const handleAlloy = (value, selected, option, index) => {
    setSelectedAlloy(value);
    const updatedDetails = form
      .getFieldValue('quotation_details')
      .map((item, i) => (i === index ? { ...item, alloy: selected } : item));

    form.setFieldsValue({ quotation_details: updatedDetails });
  };
  const handleTemer = (value, selected, option, index) => {
    setSelectedTemper(value);
    const updatedDetails = form
      .getFieldValue('quotation_details')
      .map((item, i) => (i === index ? { ...item, temper: selected } : item));

    form.setFieldsValue({ quotation_details: updatedDetails });
  };

  const debouncedSearchDieProfile = debounce((value, dispatch) => {
    dispatch(resetDieProfileData());
    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 100,
        search: value || '',
      }),
    );
  }, 300);

  const handleSearchDieProfile = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 100 }));
    }
  };

  const onScrollDieProfile = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;
      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 100,
          search: searchDieProfile || '',
        }),
      );
    }
  };

  const handleSearchAlloy = value => {
    setSearchAlloy(value);
    if (value) {
      setSearchAlloy(value);
      dispatch(resetAlloyList());
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchAlloy('');
      dispatch(resetAlloyList());
      dispatch(resetCurrentAlloyListPage());
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 10 }));
    }
  };

  const onScrollAlloy = async event => {
    const target = event.target;
    if (
      !alloyLoading &&
      alloyHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchAlloyDropdown({ page: alloyCurrentPage, pagesize: 10 }));
    }
  };

  const handleSearchTemer = value => {
    setSearchTemper(value);
    if (value) {
      setSearchTemper(value);
      dispatch(resetTempersList());
      dispatch(fetchTemperDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchTemper('');
      dispatch(resetTempersList());
      dispatch(resetCurrentTemperPage());
      dispatch(fetchTemperDropdown({ page: 1, pagesize: 10 }));
    }
  };

  const handleSearchCustomer = value => {
    setSearchCustomer(value);
    if (value) {
      setSearchCustomer(value);
      dispatch(resetCustomerList());
      dispatch(fetchCustomerDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchCustomer('');
      dispatch(resetCustomerList());
      dispatch(resetCurrentCustomerPage());
      dispatch(fetchCustomerDropdown({ page: 1, pagesize: 10 }));
    }
  };

  const handleChangeCustomer = value => {
    setSearchCustomer(value);
    setSelectCustomer(value);
  };

  const handleCompanyNameChange = async value => {
    form.setFieldValue('customer', value);
    form.validateFields(['customer']);
    handleChangeCustomer(value);

    const quotationDetails = form.getFieldValue('quotation_details') || [];
    const updatedQuotationDetails = [...quotationDetails];
    updatedQuotationDetails.forEach((item, index) => {
      updatedQuotationDetails[index] = {
        ...item,
        conversion: '',
      };
    });

    form.setFieldsValue({ quotation_details: updatedQuotationDetails });
    for (let i = 0; i < updatedQuotationDetails.length; i++) {
      const dieId = updatedQuotationDetails[i]?.die_profile;
      if (dieId) {
        await fetchConversionData(value, dieId, i);
      }
    }
  };

  const onScrollTemper = async event => {
    const target = event.target;
    if (
      !temperLoading &&
      temperHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchTemperDropdown({ page: alloyCurrentPage, pagesize: 10 }));
    }
  };

  useEffect(() => {
    dispatch(fetchCustomerDropdown({ page: 1, pagesize: 50000 }));
    dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50000 }));
    dispatch(resetCurrentDieProfilePage({ page: 1, pagesize: 50000 }));
    dispatch(fetchAlloyDropdown({ page: 1, pagesize: 50000 }));
    dispatch(fetchTemperDropdown({ page: 1, pagesize: 50000 }));
    dispatch(fetchConversionRateList({ page: 1, pagesize: 50000 }));
    dispatch(resetTempersList());
    dispatch(resetDieProfileList());
    dispatch(resetCustomerList());
    dispatch(resetAlloyList());
    dispatch(resetConversionRateList());
    dispatch(resetDieProfileData());
    resetCurrentDieProfilePage();
  }, [dispatch, page, pagesize]);

  useEffect(() => {
    if (selectedIndex === null) return;
    const workOrderDetails = form.getFieldValue('quotation_details') || [];
    const updatedDetails = [...workOrderDetails];
    const item = updatedDetails[selectedIndex];

    if (item) {
      const currentKg = currentWTKg || 0;
      const length = parseFloat(item.length) || 0;
      const pieces = parseFloat(item.pieces) || 0;
      const netWeight = ((currentKg * length) / 1000) * pieces;
      const toleranceValue = form.getFieldValue('tolerance') || '';
      const tolerancePercent = toleranceValue
        ? parseFloat(toleranceValue.replace(/[^\d.]/g, '')) || 0
        : 0;
      const isPositive = toleranceValue.includes('+');
      const isNegative = toleranceValue.includes('-');
      let max_weight = netWeight;
      let min_weight = netWeight;

      if (tolerancePercent > 0) {
        if (isPositive && isNegative) {
          max_weight = netWeight * (1 + tolerancePercent / 100);
          min_weight = netWeight * (1 - tolerancePercent / 100);
        } else if (isPositive) {
          max_weight = netWeight * (1 + tolerancePercent / 100);
          min_weight = netWeight;
        } else if (isNegative) {
          min_weight = netWeight * (1 - tolerancePercent / 100);
          max_weight = netWeight;
        }
      }
      updatedDetails[selectedIndex] = {
        ...item,
        net_weight: netWeight.toFixed(2),
      };
      form.setFieldsValue({
        quotation_details: updatedDetails,
      });
    }
  }, [currentWTKg, selectedIndex, form]);


  const handleFinish = values => {
    setBtnLoading(true);
    const formattedQuotationDate = dayjs(values.quotation_date).format(
      'YYYY-MM-DD',
    );
    const transformedQuotationDetails = values.quotation_details.map(detail => {
      const basicDetail = {
        id: detail ? detail.id : null,
        die_profile: detail?.die_profile?.value
          ? detail?.die_profile?.value
          : detail?.die_profile,
        alloy: detail.alloy
          ? typeof detail.alloy === 'object'
            ? detail.alloy.value
            : detail.alloy
          : null,
        temper: detail.temper
          ? typeof detail.temper === 'object'
            ? detail.temper.value
            : detail.temper
          : null,
        customer_reference_no: detail.customer_reference_no,
        length: detail.length,
        pieces: detail.pieces,
        net_weight: detail.net_weight,
        unit_of_measurement: detail.unit_of_measurement,
        price_per_kg: detail.price_per_kg,
        conversion: detail.conversion,
        jobworks: detail.jobworks || [],
        cutting: detail?.cutting || false,
        machining: detail?.machining || false,
        deburring: detail?.deburring || false,
        anodising: detail?.anodising || false,
        powder_coating: detail?.powder_coating || false,
        pvdf: detail?.pvdf || false,
        anodising_description: detail.anodising_description || '',
        anodising_price: parseFloat(detail.anodising_price) || null,
        powder_coating_description: detail.powder_coating_description || '',
        powder_coating_price: parseFloat(detail.powder_coating_price) || null,
        pvdf_description: detail.pvdf_description || '',
        pvdf_price: parseFloat(detail.pvdf_price) || null,
        laser_marking_description: detail.laser_marking_description || '',
        laser_marking_price: parseFloat(detail.laser_marking_price) || null,
        cutting_price: parseFloat(detail.cutting_price) || null,
        machining_price: parseFloat(detail.machining_price) || null,
        deburring_price: parseFloat(detail.deburring_price) || null,
      };
      // Only include out_source if it’s not null
      if (detail?.jobworks?.includes(4) && detail?.out_source != null) {
        basicDetail.out_source = detail?.out_source;
      }

      return basicDetail;
    });

    const payload = {
      customer: values.customer,
      quotation_date: formattedQuotationDate,
      project_name: values.project_name,
      quotation_details: transformedQuotationDetails,
      terms_and_condition: values.terms_and_condition,
      remarks: values.remarks,
      packing_mode: values.packing_mode,
    };

    dispatch(updateQuotation({ id: id, values: payload }))
      .unwrap()
      .then(result => {
        if (result.success) {
          setBtnLoading(false);
          message.success('Quotation Updated Successfully!');
          navigate('/quotation-list');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        let displayMessage = '';
        if (typeof error === 'object') {
          displayMessage = Object.entries(error)
            .map(([key, value]) => `${key}: ${value.join(', ')}`)
            .join('\n');
          message.error(displayMessage);
        } else {
          message.error(`Error: ${error || 'Failed to update the quotation.'}`);
        }
      });
  };
  const [pricePerKg, setPricePerKg] = useState('');
  const fetchConversionData = async (customerId, dieId, index) => {
    try {
      const response = await dispatch(
        fetchCustomerConversionList({
          page: 1,
          pagesize: 10,
          customer_id: customerId,
          die_id: dieId,
        }),
      );

      const updatedQuotationDetails = [
        ...form.getFieldValue('quotation_details'),
      ];

      if (response && response.payload.data.length > 0) {
        const conversionValue = response.payload.data[0].conversion;
        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          conversion: conversionValue,
          price_per_kg: pricePerKg,
        };
      } else {
        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          conversion: '',
          price_per_kg: pricePerKg,
        };
      }

      form.setFieldsValue({ quotation_details: updatedQuotationDetails });
    } catch (error) {
      console.error('Error fetching conversion data:', error);
    }
  };

  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Edit Quotation</h2>
          <div className="bredcrumbwrp">
            <Link
              className="back"
              onClick={() => {
                navigate(-1);
              }}
            >
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/quotation-list">Quotation List</Link> },
                { title: 'Edit Quotation' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          form={form}
          onFinish={handleFinish}
          autoComplete="off"
        >
          <div className="formrowsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="customer"
                  label="Company Name"
                  rules={[
                    { required: true, message: 'Please select company name' },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Please Select Company Name"
                    onChange={handleCompanyNameChange}
                    onSearch={handleSearchCustomer}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch={true}
                    value={searchCustomer}
                  >
                    {[
                      ...new Map(
                        customerDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.customer_name}
                      </Option>
                    ))}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="quotation_date"
                  label="Today Date"
                  rules={[
                    { required: true, message: 'Please select quotation date' },
                  ]}
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    style={{ width: '100%' }}
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="packing_mode"
                  label="Mode Of Packing"
                  rules={[
                    { required: true, message: 'Please select mode of packing' },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Select Mode Of Packing"
                    options={Array.from(
                      new Map(
                        packingModeList.map(item => [item.id, { label: item.name, value: item.id }])
                      ).values()
                    )}
                    mode="multiple"
                    loading={packingModeLoading}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="project_name"
                  label="Project Name"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter project name',
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Project Name"
                    onChange={e => {
                      const value = e.target.value;
                      const formattedValue = value
                        .toLowerCase()
                        .replace(/\b\w/g, char => char.toUpperCase());
                      form.setFieldsValue({ project_name: formattedValue });
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="formrowsection">
            <h3 className="rowsubtitle">Edit New Item</h3>
            <Form.List name="quotation_details">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Row
                      className="rowItem mx-0"
                      gutter={[24, 24]}
                      align="middle"
                      key={key}
                      style={{ width: '100%', flexWrap: 'nowrap' }}
                    >
                      <Col flex="auto">
                        <Row gutter={16}>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'die_profile']}
                              label="Section Number"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select section number',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Section Number"
                                labelInValue
                                value={
                                  form.getFieldValue([
                                    'quotation_details',
                                    name,
                                    'die_profile',
                                  ])
                                    ? {
                                      value: form.getFieldValue([
                                        'quotation_details',
                                        name,
                                        'die_profile',
                                      ]),
                                      label: '',
                                    }
                                    : undefined
                                }
                                onChange={value =>
                                  handleDieProfileChange(value, name)
                                }
                                // onSearch={handleSearchDieProfile}
                                // className={getClassNameDieProfile(name)}
                                allowClear
                                onClear={() => {
                                  dispatch(resetDieProfileData());
                                  dispatch(
                                    fetchDieProfileDropdown({
                                      page: 1,
                                      pagesize: 100,
                                    }),
                                  );
                                }}
                                showSearch={true}
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                loading={dieProfileLoading}
                                onPopupScroll={onScrollDieProfile}
                                notFoundContent={
                                  dieProfileLoading
                                    ? 'Loading...'
                                    : 'No options'
                                }
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {[
                                  ...new Map(
                                    dieProfileDropdown.map(item => [
                                      item.id,
                                      item,
                                    ]),
                                  ).values(),
                                ].map((el, index) => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.die_number}
                                  </Option>
                                ))}
                              </AutoOpenSelect>
                            </Form.Item>
                            {form.getFieldValue([
                              'quotation_details',
                              name,
                              'customer_reference_no',
                            ]) && (
                                <div
                                  style={{
                                    marginTop: '4px',
                                    marginBottom: '16px',
                                    paddingLeft: '0px',
                                  }}
                                >
                                  <span style={{ fontSize: '12px', color: '#666' }}>
                                    <b>Customer Ref No:</b>{' '}
                                    <span style={{ color: '#333' }}>
                                      {form.getFieldValue([
                                        'quotation_details',
                                        name,
                                        'customer_reference_no',
                                      ])}
                                    </span>
                                  </span>
                                </div>
                              )}
                          </Col>

                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'alloy']}
                              label="Alloy"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select alloy',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Alloy"
                                loading={alloyLoading}
                                onPopupScroll={onScrollAlloy}
                                notFoundContent={
                                  alloyLoading ? 'Loading...' : 'No options'
                                }
                                value={searchAlloy}
                                onChange={(value, option) =>
                                  handleAlloy(value, option)
                                }
                                allowClear
                                showSearch={true}
                                filterOption={(input, option) => {
                                  if (!input) return true;

                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();

                                  return optionText.includes(inputText);
                                }}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {alloyDropdown.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.alloy_code} - {el.standard_name}
                                  </Option>
                                ))}
                                {alloyLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'temper']}
                              label="Temper"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select temper',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Temper"
                                loading={temperLoading}
                                value={searchTemper}
                                onPopupScroll={onScrollTemper}
                                notFoundContent={
                                  temperLoading ? 'Loading...' : 'No options'
                                }
                                onChange={(value, option) =>
                                  handleTemer(value, option)
                                }
                                // className={getClassNameTemer(name)}
                                onSearch={handleSearchTemer}
                                allowClear
                                showSearch={true}
                                filterOption={(input, option) => {
                                  if (!input) return true;
                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  return optionText.includes(inputText);
                                }}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {temperDropDown.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.temper_code_new} - {el.temper_code_old}
                                  </Option>
                                ))}
                                {temperLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'length']}
                              label="Length (mm)"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter length',
                                },
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 7,
                                  maxAfterDecimal: 3,
                                  allowDecimal: true,
                                }),
                              ]}
                            >
                              <Input
                                placeholder="0"
                                onChange={() => {
                                  setTimeout(
                                    () => handleFieldChange(index, 'length'),
                                    0,
                                  );
                                }}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'pieces']}
                              label="Pieces"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter pieces',
                                },
                                {
                                  pattern: /^[1-9]\d{0,5}$/,
                                  message: 'Pieces must be between 1 and 999999',
                                },
                              ]}
                            >
                              <Input
                                placeholder="0"
                                onChange={() => {
                                  setTimeout(
                                    () => handleFieldChange(index, 'pieces'),
                                    0,
                                  );
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'net_weight']}
                              label="Net Weight (kg)"
                              rules={[
                                {
                                  required: true,
                                  message:
                                    'Enter a valid number with up to 3 decimal places',
                                },
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 7,
                                  maxAfterDecimal: 3,
                                  allowDecimal: true,
                                }),
                              ]}
                            >
                              <Input
                                placeholder="0.0"
                                onChange={() => {
                                  setTimeout(
                                    () =>
                                      handleFieldChange(index, 'net_weight'),
                                    0,
                                  );
                                }}
                              />
                            </Form.Item>
                          </Col>

                          {form.getFieldValue([
                            'quotation_details',
                            name,
                            'surface_finish',
                          ]) &&
                            form.getFieldValue([
                              'quotation_details',
                              name,
                              'surface_finish',
                            ]) !== 'Mill Finish' && (
                              <>
                                <Col xs={12} sm={8} xl={4}>
                                  <Form.Item
                                    name={[name, 'surface_treatment']}
                                    label="Surface Treatment"
                                  >
                                    <Input placeholder="Enter Surface Treatment" />
                                  </Form.Item>
                                </Col>
                                <Col xs={12} sm={8} xl={4}>
                                  <Form.Item
                                    name={[name, 'description']}
                                    label="Description"
                                  >
                                    <Input placeholder="Enter Description" />
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'unit_of_measurement']}
                              label="UOM"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select a measurement unit',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select UOM"
                                showSearch={true}
                                allowClear
                                filterOption={(input, option) => {
                                  if (!input) return true;
                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  return optionText.includes(inputText);
                                }}
                              >
                                <Option value="kg">Kg</Option>
                                <Option value="piece">Piece</Option>
                                <Option value="rmt">RMT</Option>
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'price_per_kg']}
                              label="Price per kg"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Price per kg',
                                },
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 7,
                                  maxAfterDecimal: 3,
                                  allowDecimal: true,
                                  allowZero: true,
                                }),
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>

                          {form.getFieldValue([
                            'quotation_details',
                            name,
                            'surface_finish',
                          ]) &&
                            form.getFieldValue([
                              'quotation_details',
                              name,
                              'surface_finish',
                            ]) !== 'Mill Finish' && (
                              <Col xs={12} sm={8} xl={4}>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'finishing_price']}
                                  label="Finishing Price"
                                  rules={[
                                    createNumberValidationRule({
                                      allowNegative: false,
                                      maxBeforeDecimal: 7,
                                      maxAfterDecimal: 3,
                                      allowDecimal: true,
                                      allowZero: true,
                                    }),
                                  ]}
                                >
                                  <Input placeholder="0.0" />
                                </Form.Item>
                              </Col>
                            )}
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'conversion']}
                              label="Conversion"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid conversion',
                                },
                                {
                                  pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
                                  message: 'Enter valid conversion (up to 2 decimals)',
                                },
                              ]}
                            >
                              <Input
                                placeholder="0.00"

                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'jobworks']}
                              label="Surface finish"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select jobwork',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Jobwork"
                                mode="multiple"
                                value={form.getFieldValue([
                                  'quotation_details',
                                  name,
                                  'jobworks',
                                ])}
                                allowClear
                                showSearch
                                optionFilterProp="children"

                                loading={jobWorkLoading}
                                onChange={(value) => {
                                  const selectedItems = jobWorkdata?.filter(item => value.includes(item.id));
                                  const selectedNames = selectedItems.map(item => item.name);

                                  const engineeringId = jobWorkdata?.find(item => item.name === "Engineering")?.id;
                                  const surfaceTreatmentId = jobWorkdata?.find(item => item.name === "Surface treatment")?.id;

                                  const details = form.getFieldValue("quotation_details") || [];
                                  if (!details[index]) return;
                                  const newDetails = [...details];


                                  // Delete Engineering-related fields if deselected
                                  if (!value.includes(engineeringId)) {
                                    ["cutting", "machining", "deburring"].forEach(opt => {
                                      if (newDetails[index][opt] !== undefined) delete newDetails[index][opt]; // remove boolean
                                      //if (newDetails[index][`${opt}_price`] !== undefined) delete newDetails[index][`${opt}_price`]; // remove price
                                    });
                                  }

                                  // Delete Surface Treatment -related fields if deselected
                                  if (!value.includes(surfaceTreatmentId)) {
                                    ["anodising", "powder_coating", "pvdf"].forEach(opt => {
                                      if (newDetails[index][opt] !== undefined) delete newDetails[index][opt]; // remove boolean
                                      if (newDetails[index][`${opt}_description`] !== undefined) delete newDetails[index][`${opt}_description`]; // remove description
                                      //if (newDetails[index][`${opt}_price`] !== undefined) delete newDetails[index][`${opt}_price`]; // remove price
                                    });
                                  }

                                  form.setFieldsValue({ inquiry_details: newDetails });
                                }}
                              >
                                {jobWorkLoading ? (
                                  <Option key="loading" disabled>
                                    Loading...
                                  </Option>
                                ) : (
                                  jobWorkdata?.map(item => (
                                    <Option key={item.id} value={item.id}>
                                      {item.name}
                                    </Option>
                                  ))
                                )}
                              </AutoOpenSelect>

                            </Form.Item>
                          </Col>

                          <Form.Item
                            shouldUpdate={(prevValues, currentValues) =>
                              prevValues.quotation_details?.[index]?.jobworks !==
                              currentValues.quotation_details?.[index]?.jobworks
                            }
                            noStyle
                          >
                            {({ getFieldValue }) => {
                              const selectedSurfaceFinish = getFieldValue(["quotation_details", index, "jobworks"]) || [];

                              const selectedItems = jobWorkdata?.filter(item => selectedSurfaceFinish.includes(item.id));


                              // Example: show conditional field if Laser Marking selected
                              const hasEngineering = selectedItems.some(item => item.name === "Engineering");
                              const hasSurfaceTreatment = selectedItems.some(item => item.name === "Surface treatment");

                              return (
                                <>
                                  {/* --- Engineering Fields --- */}
                                  {hasEngineering && (
                                    <>
                                      <Form.Item
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                          prev.quotation_details?.[index]?.cutting !== curr.quotation_details?.[index]?.cutting ||
                                          prev.quotation_details?.[index]?.machining !== curr.quotation_details?.[index]?.machining ||
                                          prev.quotation_details?.[index]?.deburring !== curr.quotation_details?.[index]?.deburring
                                        }
                                      >
                                        {({ getFieldValue }) => {
                                          const cutting = getFieldValue(['quotation_details', index, 'cutting']);
                                          const machining = getFieldValue(['quotation_details', index, 'machining']);
                                          const deburring = getFieldValue(['quotation_details', index, 'deburring']);

                                          return (
                                            <>
                                            <Col xs={12} md={8} xl={6} xxl={6} style={{ marginTop: '24px' }}>
                                              <Form.Item
                                                name={[name, "cutting"]}
                                                valuePropName="checked"
                                                noStyle
                                              >
                                                <Checkbox>Cutting</Checkbox>
                                              </Form.Item>

                                              <Form.Item
                                                name={[name, "machining"]}
                                                valuePropName="checked"
                                                noStyle
                                              >
                                                <Checkbox>Machining</Checkbox>
                                              </Form.Item>

                                              <Form.Item
                                                name={[name, "deburring"]}
                                                valuePropName="checked"
                                                noStyle
                                              >
                                                <Checkbox>Deburring</Checkbox>
                                              </Form.Item>
                                              </Col>
                                              {cutting && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Cutting Price"
                                                    name={[name, 'cutting_price']}
                                                    rules={[{ required: true, message: 'Enter Cutting Price' }]}
                                                  >
                                                    <Input placeholder="0.0" />
                                                  </Form.Item>
                                                </Col>
                                              )}

                                              {machining && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Machining Price"
                                                    name={[name, 'machining_price']}
                                                    rules={[{ required: true, message: 'Enter Machining Price' }]}
                                                  >
                                                    <Input placeholder="0.0" />
                                                  </Form.Item>
                                                </Col>
                                              )}

                                              {deburring && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Deburring Price"
                                                    name={[name, 'deburring_price']}
                                                    rules={[{ required: true, message: 'Enter Deburring Price' }]}
                                                  >
                                                    <Input placeholder="0.0" />
                                                  </Form.Item>
                                                </Col>
                                              )}
                                            </>
                                          );
                                        }}
                                      </Form.Item>
                                    </>
                                  )}
                                  {/* --- Surface Treatment Fields --- */}
                                  {hasSurfaceTreatment && (
                                    <>


                                      {/* Nested conditional price fields */}
                                      <Form.Item
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                          prev.quotation_details?.[index]?.anodising !== curr.quotation_details?.[index]?.anodising ||
                                          prev.quotation_details?.[index]?.powder_coating !== curr.quotation_details?.[index]?.powder_coating ||
                                          prev.quotation_details?.[index]?.pvdf !== curr.quotation_details?.[index]?.pvdf
                                        }
                                      >
                                        {({ getFieldValue }) => {
                                          const anodising = getFieldValue(["quotation_details", index, "anodising"]);
                                          const powder_coating = getFieldValue(["quotation_details", index, "powder_coating"]);
                                          const pvdf = getFieldValue(["quotation_details", index, "pvdf"]);
                                          return (
                                            <>
                                             <Col xs={12} md={8} xl={6} xxl={6} style={{ marginTop: '24px' }}>
                                              <Form.Item
                                                name={[name, "anodising"]}
                                                valuePropName="checked"
                                                noStyle
                                              >
                                                <Checkbox>Anodising</Checkbox>
                                              </Form.Item>

                                              <Form.Item
                                                name={[name, "powder_coating"]}
                                                valuePropName="checked"
                                                noStyle
                                              >
                                                <Checkbox>Powder Coating</Checkbox>
                                              </Form.Item>

                                              <Form.Item
                                                name={[name, "pvdf"]}
                                                valuePropName="checked"
                                                noStyle
                                              >
                                                <Checkbox>PVDF</Checkbox>
                                              </Form.Item>
                                              </Col>
                                              {anodising && (
                                                <>
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Anodising Description"
                                                      name={[name, "anodising_description"]}
                                                      rules={[{ required: true, message: "Enter Anodising Description" }]}
                                                    >
                                                      <Input placeholder="Enter Anodising Description" />
                                                    </Form.Item>
                                                  </Col>
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Anodising Price"
                                                      name={[name, "anodising_price"]}
                                                      rules={[{ required: true, message: "Enter Anodising Price" }]}
                                                    >
                                                      <Input placeholder="Enter Anodising Price" />
                                                    </Form.Item>
                                                  </Col>
                                                </>
                                              )}

                                              {powder_coating && (
                                                <>
                                                  <Col xs={12} md={8} xl={4}>
                                                    <Form.Item
                                                      label="Powder Coating Description"
                                                      name={[name, "powder_coating_description"]}
                                                      rules={[{ required: true, message: "Enter Powder Coating Description" }]}
                                                    >
                                                      <Input placeholder="Enter Powder Coating Description" />
                                                    </Form.Item>
                                                  </Col>
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Powder Coating Price"
                                                      name={[name, "powder_coating_price"]}
                                                      rules={[{ required: true, message: "Enter Powder Coating Price" }]}
                                                    >
                                                      <Input placeholder="Enter Powder Coating Price" />
                                                    </Form.Item>
                                                  </Col>
                                                </>
                                              )}

                                              {pvdf && (
                                                <>
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="PVDF Description"
                                                      name={[name, "pvdf_description"]}
                                                      rules={[{ required: true, message: "Enter PVDF Description" }]}
                                                    >
                                                      <Input placeholder="Enter PVDF Description" />
                                                    </Form.Item>
                                                  </Col>
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="PVDF Price"
                                                      name={[name, "pvdf_price"]}
                                                      rules={[{ required: true, message: "Enter PVDF Price" }]}
                                                    >
                                                      <Input placeholder="Enter PVDF Price" />
                                                    </Form.Item>
                                                  </Col>
                                                </>
                                              )}
                                            </>
                                          );
                                        }}
                                      </Form.Item>
                                    </>
                                  )}
                                </>
                              );
                            }}
                          </Form.Item>

                        </Row>
                      </Col>
                      <Col>
                        <div className="addwrp">
                          {index !== 0 && (
                            <Button
                              type="primary"
                              danger
                              icon={<MinusCircleOutlined />}
                              onClick={() => remove(name)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '30px',
                              }}
                            />
                          )}
                        </div>
                      </Col>
                    </Row>
                  ))}
                  <Form.Item>
                    <div className="w-100 flex justify-end ">
                      <Button
                        type="primary"
                        onClick={() => {
                          if (fields.length < 500) {
                            dispatch(resetDieProfileData());
                            dispatch(
                              fetchDieProfileDropdown({ page: 1, pagesize: 100 }),
                            );
                            setSearchDieProfile('');
                            add({ price_per_kg: pricePerKg });
                          } else {
                            message.error('You can only add up to 15 records.');
                          }
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Item
                      </Button>
                    </div>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
          <Row gutter={16}>
            <Col xs={24}>
              <Form.Item
                name="terms_and_condition"
                label="Terms & Condition"
                rules={[
                  { required: true, message: 'Terms & Condition is required' },
                ]}
                valuePropName="content"
              >
                <ReactQuill
                  value={editorValue}
                  onChange={handleChange}
                  theme="snow"
                  modules={{
                    toolbar: [
                      [{ header: '1' }, { header: '2' }, { font: [] }],
                      [{ list: 'ordered' }, { list: 'bullet' }],
                      ['bold', 'italic', 'underline'],
                      [{ align: [] }],
                      ['link', 'image'],
                      ['blockquote', 'code-block'],
                    ],
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item name="remarks" label="Remarks">
                <Input.TextArea
                  placeholder="Enter Remarks"
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ remarks: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              icon={<PlusOutlined />}
              loading={btnLoading}
            >
              Edit Quotation
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}
